import type React from 'react';
import { useMemo } from 'react';
import DocumentTitle from 'react-document-title';

export type DocumentTitleOwnProps = {
  readonly title?: string | string[];
  readonly ignoreProject?: boolean;
  readonly children?: React.ReactChild | null;
};

export type DocumentTitleStateProps = {
  readonly projectName?: string;
};

const delimiter = ' - ';

export type DocumentTitleProps = DocumentTitleOwnProps & DocumentTitleStateProps;

export const DocumentProjectTitle: React.FC<DocumentTitleProps> = (props) => {
  const { title, projectName, ignoreProject, children } = props;
  const docTitle = useMemo(() => {
    let docTitle = Array.isArray(title) ? title.join(delimiter) : title;
    if (projectName && !ignoreProject) {
      docTitle = [projectName].concat(title ?? []).join(delimiter);
    }

    return docTitle;
  }, [title, projectName, ignoreProject]);
  return <DocumentTitle title={docTitle ?? ''}>{children}</DocumentTitle>;
};

export default DocumentProjectTitle;
